import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=6f850602&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=6f850602&prod&lang=scss&scoped=true"
import style1 from "./detail.vue?vue&type=style&index=1&id=6f850602&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f850602",
  null
  
)

export default component.exports